(() => {
  const TRACK_SELECTOR = '.tee-thumbnails__track';
  const ACTIVE_SELECTOR = [
    '.tee-thumbnail--active',
    '.tee-thumbnail.active',
    '.tee-thumbnail.is-active',
    '.tee-thumbnail[aria-current="true"]',
    '.tee-thumbnail[aria-selected="true"]',
  ].join(', ');
  const wishlistButton = document.querySelector('.product__media-wrapper > .pra-wishlist-button');

  const isTeeInBluePage = () => document.body.classList.contains('teeinblue-enabled');

  function bindWishlistToGallery() {
    if (!isTeeInBluePage() || !wishlistButton) return;

    const galleryHost = document.querySelector('.product__media-wrapper .tee-gallery-content');
    if (!galleryHost || wishlistButton.parentElement === galleryHost) return;

    galleryHost.appendChild(wishlistButton);
  }

  function syncPreviewOpenState() {
    if (!isTeeInBluePage()) {
      document.body.classList.remove('pra-tee-preview-open');
      return;
    }

    const previewDialog = document.querySelector('.tee-dialog-gallery');
    const previewIsOpen = Boolean(previewDialog?.getClientRects().length);

    if (previewIsOpen) {
      document.querySelectorAll('#teeFormActions .tee-form-responses .tee-error').forEach((error) => error.remove());
    }

    if (!window.matchMedia('(max-width: 749px)').matches) {
      document.body.classList.remove('pra-tee-preview-open');
      return;
    }

    document.body.classList.toggle('pra-tee-preview-open', previewIsOpen);
  }

  function fitDesktopMockupInsideStage() {
    const stages = document.querySelectorAll('.tee-gallery__stage');

    if (!isTeeInBluePage() || !window.matchMedia('(min-width: 990px)').matches) {
      stages.forEach((stage) => stage.style.removeProperty('--pra-tee-mockup-scale'));
      return;
    }

    const stage = document.querySelector('.tee-gallery__stage');
    const activeSlide = stage?.querySelector('.tee-slide--active') || stage?.querySelector('.tee-slide');
    const mockup = activeSlide?.querySelector('.tee-mockup');
    if (!stage || !mockup) return;

    const stageRect = stage.getBoundingClientRect();
    const baseWidth = Number.parseFloat(mockup.style.width) || mockup.offsetWidth;
    const baseHeight = Number.parseFloat(mockup.style.height) || mockup.offsetHeight;
    if (stageRect.width < 100 || stageRect.height < 100 || baseWidth < 100 || baseHeight < 100) return;

    const scale = Math.min(stageRect.width / baseWidth, stageRect.height / baseHeight);
    stage.style.setProperty('--pra-tee-mockup-scale', scale.toFixed(5));
  }

  function keepActiveThumbnailVisible(track, behavior = 'auto') {
    if (!isTeeInBluePage() || !track) return;

    const active = track.querySelector(ACTIVE_SELECTOR);
    if (!active) return;

    const trackRect = track.getBoundingClientRect();
    const activeRect = active.getBoundingClientRect();
    const isMobile = window.matchMedia('(max-width: 749px)').matches;

    if (isMobile) {
      const targetLeft = Math.max(0, active.offsetLeft - (track.clientWidth - active.offsetWidth) / 2);
      track.scrollTo({ left: targetLeft, behavior });
      return;
    }

    if (activeRect.top < trackRect.top) {
      track.scrollTo({ top: track.scrollTop - (trackRect.top - activeRect.top), behavior });
    } else if (activeRect.bottom > trackRect.bottom) {
      track.scrollTo({ top: track.scrollTop + (activeRect.bottom - trackRect.bottom), behavior });
    }
  }

  function bindTrack(track) {
    if (!track || track.dataset.praActiveThumbSync === 'true') return;
    track.dataset.praActiveThumbSync = 'true';

    const observer = new MutationObserver(() => keepActiveThumbnailVisible(track, 'smooth'));
    observer.observe(track, {
      attributes: true,
      attributeFilter: ['class', 'aria-current', 'aria-selected'],
      childList: true,
      subtree: true,
    });

    keepActiveThumbnailVisible(track);
  }

  function bindAvailableTracks(root = document) {
    root.querySelectorAll?.(TRACK_SELECTOR).forEach(bindTrack);
  }

  document.addEventListener('click', (event) => {
    if (!isTeeInBluePage() || !event.target.closest('.tee-slider__button, .tee-thumbnail')) return;

    [0, 80, 220].forEach((delay) => {
      window.setTimeout(() => document.querySelectorAll(TRACK_SELECTOR).forEach((track) => {
        keepActiveThumbnailVisible(track, delay ? 'smooth' : 'auto');
        fitDesktopMockupInsideStage();
      }), delay);
    });
  });

  let previewStateFrame = 0;
  const scheduleGallerySync = () => {
    if (previewStateFrame) return;
    previewStateFrame = window.requestAnimationFrame(() => {
      previewStateFrame = 0;
      bindWishlistToGallery();
      bindAvailableTracks();
      syncPreviewOpenState();
      fitDesktopMockupInsideStage();
    });
  };
  const galleryObserver = new MutationObserver(scheduleGallerySync);
  galleryObserver.observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('resize', scheduleGallerySync);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      bindWishlistToGallery();
      bindAvailableTracks();
      syncPreviewOpenState();
      fitDesktopMockupInsideStage();
    }, { once: true });
  } else {
    bindWishlistToGallery();
    bindAvailableTracks();
    syncPreviewOpenState();
    fitDesktopMockupInsideStage();
  }
})();
